// extracted by mini-css-extract-plugin
export var container = "_38-0";